import { connect } from 'react-redux';
import React from 'react';
import { Link } from 'react-router-dom';
import * as selectors from 'app/selectors';

var ParkingTimeLine = class extends React.Component {render()


  {
    return (
      <div className="kb-content" style={{ paddingTop: 0 }}>
        <div className="kb-content-container clear-fix">
          <header className="nav-section-header clear-fix border-bottom">
            <div className="nav-section-header-title f-left">
              <span>车位时间轴</span>
            </div>
          </header>
        </div>
      </div>);

  }};


function mapStateToProps(state, props) {
  const { params, location } = props;

  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ParkingTimeLine);
